import React from 'react';
import useWebShare from 'react-use-web-share';
import { useEulaModalState } from '../../hooks';
import CopyRequestAccessUrl from '../CopyRequestAccessUrl';
import { EulaModal } from '../EulaModal';

export interface RequestAccessButtonProps {
  accessPointName: string;
  propertyName: string;
  requestAccessUrl: string;
  supportPhoneNumber?: string | null;
  isVirtualDirectoryEnabled: boolean;
  onSuccess: () => void;
  onError: () => void;
}

const RequestAccessButton: React.FC<RequestAccessButtonProps> = ({
  accessPointName,
  propertyName,
  requestAccessUrl,
  supportPhoneNumber,
  onSuccess,
  onError,
  isVirtualDirectoryEnabled,
}) => {
  const { loading, isSupported, share } = useWebShare(onSuccess, onError);
  const { acceptedEulaAt, isEulaModalOpen, openEulaModal, closeEulaModal } = useEulaModalState();

  if (!isSupported) {
    return (
      <>
        <CopyRequestAccessUrl
          hasAcceptedEula={Boolean(acceptedEulaAt)}
          openEulaModal={openEulaModal}
          propertyName={propertyName}
          supportPhoneNumber={supportPhoneNumber}
          requestAccessUrl={requestAccessUrl}
          isVirtualDirectoryEnabled={isVirtualDirectoryEnabled}
        />
        <EulaModal
          isOpen={isEulaModalOpen}
          closeModal={closeEulaModal}
        />
      </>
    );
  }

  const config = {
    title: 'Request Entry Access',
    // tslint:disable-next-line max-line-length
    text: `Hey, I'm at ${accessPointName}. Please approve my access request by tapping the link below:\n\n`,
    url: requestAccessUrl,
  };

  return (
    <>
      <button
        className={`blue-button w-inline-block${loading ? 'disabled-button' : ''}`}
        style={{ borderBottom: '1px solid white' }}
        disabled={loading}
        onClick={() => {
          if (acceptedEulaAt) {
            share(config);
          } else {
            openEulaModal();
          }
        }}
      >
        <span
          className="display-flex-wrapper"
          style={{ alignItems: 'flex-start', textAlign: 'left' }}
        >
          <h1 className="h2">Contact Resident</h1>
          <span className="p text-white">
            Request access from a resident in your phone contacts
          </span>
        </span>
        <img src="/images/users.png" alt="" className="icon-20px" />
      </button>
      <EulaModal
        isOpen={isEulaModalOpen}
        closeModal={closeEulaModal}
        onAcceptEula={() => {
          share(config);
        }}
      />
    </>
  );
};

export default RequestAccessButton;
